'use strict';

var React = require('react'),
    Analytics = require('../utils/Analytics'),
    AnalyticsEvents = require('../constants/AnalyticsEvents'),
    FormMixin = require('../mixins/FormMixin'),
    FormInputRow = require('../molecules/FormInputRow'),
    Textarea = require('../atoms/Textarea'),
    Icon = require('../atoms/Icon'),
    Button = require('../atoms/Button'),
    validateRequiredString = require('../utils/validateRequiredString'),
    UserActionCreators = require('../actions/UserActionCreators'),
    SafeLocalStorage = require('../utils/SafeLocalStorage'),
    PureRenderMixin = require('../mixins/PureRenderMixin');

var UNSENT_FEEDBACK_KEY = 'components.pages.Feedback.unsentFeedback';

var Feedback = React.createClass({
  mixins: [FormMixin, PureRenderMixin],

  propTypes: {
    onCloseClick: React.PropTypes.func.isRequired
  },

  getInitialState: function () {
    return {
      text: this.getFeedbackFromLocalStorage() || ''
    };
  },

  componentDidUpdate: function () {
    if (this.isFormSubmitted()) {
      this.clearFeedbackInLocalStorage();
    } else if (this.isFormEditable()) {
      this.saveFeedbackToLocalStorage();
    }
  },

  componentWillUnmount: function () {
    if (this.isFormSubmitted()) {
      this.clearFeedbackInLocalStorage();
    }
  },

  render: function () {
    return (
      <div className='Modal-body Feedback'>
        <div className='Modal-header'>
          <h3 className='Modal-title'>
            Send Feedback
          </h3>
          <div onTouchTap={this.props.onCloseClick} className='Modal-close'>
            <Icon name='cross' size='small' mode='stroke' />
          </div>
        </div>
        <div className='Modal-content'>
          <p className='Modal-message'>
            Tell us about your idea, question or problem.
          </p>
          <div className='Form'>
            <FormInputRow component={Textarea}
                          label='Type your message'
                          formLink={this.linkValidatedState('text', validateRequiredString)}
                          readOnly={!this.isFormEditable()} />
          </div>
        </div>
        {this.renderFooter()}
      </div>
    );
  },

  renderFooter: function () {
    return (
      <div className='Modal-footer'>
        <Button color='green'
                onClick={this.submitForm.bind(this, this.sendRequest)}
                disabled={!this.isFormEditable()}
                size='large'>
          Send
        </Button>
      </div>
    );
  },

  sendRequest: function () {
    var data = {
      'feedback': this.state.text,
      'current_url': window.location.href
    };

    UserActionCreators.sendFeedback(data);
    Analytics.trackEvent(AnalyticsEvents.FORMS_FEEDBACK_SEND);
  },

  getFeedbackFromLocalStorage: function () {
    return SafeLocalStorage.getItem(UNSENT_FEEDBACK_KEY);
  },

  saveFeedbackToLocalStorage: function () {
    SafeLocalStorage.setItem(UNSENT_FEEDBACK_KEY, this.state.text);
  },

  clearFeedbackInLocalStorage: function () {
    SafeLocalStorage.removeItem(UNSENT_FEEDBACK_KEY);
  }
});

module.exports = Feedback;



/** WEBPACK FOOTER **
 ** ./modals/Feedback.jsx
 **/